import React, { useState } from "react";
import { DialogBox } from "../../../../../components/Elements/DialogBox";
import CustomSelect from "../../../../../components/Elements/Select/CustomSelect";
import { Button, Input, Radio } from "antd";
import CustomButton from "../../../../../components/Elements/Buttons/CustomButtons";
import { getApi, postApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { CheckOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import PopupCard from "../../../../Auth/PopupCard";
const formList = [
  { label: "Single Select", value: "single-select" },
  { label: "Multiple Select", value: "multi-select" },
  { label: "Date", value: "date" },
  { label: "Date Time", value: "date-time" },
  { label: "Free text", value: "free-text" },
  { label: "Dropdown", value: "dropdown" },
  { label: "Numeric", value: "Numeric" },
];

const AddQuestion = ({
  onOpen,
  onClose,
  sectionId,
  subSectionId,
  onSuccess,
}) => {
  const [questions, setQuestions] = useState([
    {
      questiontype: null,
      questionText: "",
      questionGuidance: "",
      emissionFactor: null,
    },
  ]);
  const [questionData, setQuestionData] = useState({});
  const token = useSelector((state) => state.auth.authToken);
  const [errorMessages, setErrorMessages] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    type: "success",
    title: "Success",
    message: "",
  });
  const handleSelectForm = (index, value) => {
    const updatedQuestions = [...questions];
    updatedQuestions[index].questiontype = value;
    setQuestions(updatedQuestions);
  };

  const handleChange = (index, field, value) => {
    const updatedQuestions = [...questions];
    updatedQuestions[index][field] = value;
    setQuestions(updatedQuestions);
  };

  const addMoreQuestion = () => {
    setQuestions([
      ...questions,
      {
        questiontype: null,
        questionText: "",
        questionGuidance: "",
        emissionFactor: null,
      },
    ]);
  };
  const triggerPopup = (type, title, message, duration = 2000) => {
    setPopupData({ type, title, message });
    setShowPopup(true);
    setTimeout(
      () => setShowPopup(false),

      duration,
    );
  };
  const createQuestion = async () => {
    try {
      const response = await postApi({
        apiUrl: API_URLS.CREATE_QUESTION,
        data: {
          customSectionId: sectionId,
          customSubsectionId: subSectionId,
          label: questions[0].questionText,
        },
        token: token,
      });
      if (response.success) {
        setQuestionData(response.data);
        onSuccess(response.data);
        //toast.success("Question Created Successfully");
        // Modal.success({
        //   icon: null,
        //   centered: true,
        //   closable: true,
        //   className: "custom-success-modal",
        //   okButtonProps: { style: { display: "none" } },
        //   content: (
        //     <div className="flex flex-col items-center text-center p-4">
        //       <div className="bg-slate-300 p-2 rounded-full">
        //         <CheckOutlined style={{ fontSize: "48px", color: "#06513D" }} />
        //       </div>

        //       <p className="text-[15px] mt-2 mb-1 font-medium">Success!</p>
        //       <h2 className="text-xl font-semibold text-[#000000]">
        //         Question Created Successfully
        //       </h2>
        //     </div>
        //   ),
        // });

        triggerPopup("success", "Success", "Question Created Successfully");

        setTimeout(() => {
          Modal.destroyAll(); // Close all modals
          // handleSuccessComplete();
          onClose();
        }, 2000);

        // onClose();
      }
    } catch (error) {
      console.error("Error in updating status", error);
    }
  };

  const handleSave = async () => {
    let isValid = true;
    const newErrors = questions.map((q) => {
      let error = {};
      // if (!q.questiontype) error.questiontype = "Question Type is required.";
      if (!q.questionText.trim())
        error.questionText = "Question Text is required.";
      // if (!q.questionGuidance.trim()) error.questionGuidance = "Question Guidance is required.";
      // if (q.emissionFactor === null) error.emissionFactor = "Please select an option for 'Has Emission Factor'.";

      if (Object.keys(error).length > 0) isValid = false;
      return error;
    });

    setErrorMessages(newErrors);

    if (isValid) {
      try {
        await createQuestion();
      } catch (error) {
        console.error("Error in createQuestion:", error);
      }
    }
  };

  const handleCancel = () => {
    setQuestions([
      {
        questiontype: null,
        questionText: "",
        questionGuidance: "",
        emissionFactor: null,
      },
    ]);
    setErrorMessages([]);
    onClose();
  };

  return (
    <div className="flex justify-center my-4">
      <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="750px">
        <div>
          <h3 className="text-2xl">Add Question </h3>
          <hr className="py-4" style={{ color: "1px solid #ebedf3" }} />
          {questions.map((q, index) => (
            <div
              key={index}
              style={{
                border: "1px solid #ebedf3",
                borderRadius: "10px",
                padding: "20px",
                marginBottom: "20px",
              }}
            >
              {/* Question type Selection */}
              {/* <label className="mb-2 block">Question Type</label>
              <CustomSelect
                options={formList}
                mode="single"
                placeholder="Please Select"
                height="40px"
                value={q.questiontype}
                onChange={(value) => handleSelectForm(index, value)}
              />
              {errorMessages[index]?.questiontype && (
                <div className="text-red-500 text-sm mt-1">
                  {errorMessages[index].questiontype}
                </div>
              )} */}

              {/* Question Text or Label */}
              <div className="mt-4">
                <label className="mb-2 block">Question Text</label>
                <Input
                  value={q.questionText}
                  onChange={(e) =>
                    handleChange(index, "questionText", e.target.value)
                  }
                  placeholder="Enter question"
                  className="h-14 rounded-lg"
                />
                {errorMessages[index]?.questionText && (
                  <div className="text-red-500 text-sm mt-1">
                    {errorMessages[index].questionText}
                  </div>
                )}
              </div>

              {/* Question Guidance */}
              {/* <div className="mt-4">
                <label className="mb-2 block">Question Guidance</label>
                <Input
                  value={q.questionGuidance}
                  onChange={(e) =>
                    handleChange(index, "questionGuidance", e.target.value)
                  }
                  placeholder="Enter guidance"
                  className="h-14 rounded-lg"
                />
                {errorMessages[index]?.questionGuidance && (
                  <div className="text-red-500 text-sm mt-1">
                    {errorMessages[index].questionGuidance}
                  </div>
                )}
              </div> */}

              {/* Emission Factor (Yes/No) */}
              {/* <div className="mt-4">
                <label className="mb-2 block">Has Emission Factor*</label>
                <Radio.Group
                  onChange={(e) =>
                    handleChange(index, "emissionFactor", e.target.value)
                  }
                  value={q.emissionFactor}
                >
                  <Radio value="yes">Yes</Radio>
                  <Radio value="no">No</Radio>
                </Radio.Group>
                {errorMessages[index]?.emissionFactor && (
                  <div className="text-red-500 text-sm mt-1">
                    {errorMessages[index].emissionFactor}
                  </div>
                )}
              </div> */}

              {/* + Add More Question Button */}
              {/* <div className="flex justify-start  mt-6">
                <button
                  onClick={addMoreQuestion}
                  style={{
                    color: "#088F8F",
                    background: "#e7fefe",
                  }}
                  className="  px-4 py-2 rounded-lg"
                >
                  + Add More Question
                </button>
              </div> */}
            </div>
          ))}
          {/* Buttons Section */}
          <div className="flex justify-center gap-4 py-6">
            <CustomButton
              buttonType="primary"
              variant="cancel"
              buttonText="Cancel"
              className="text-sm px-6 py-2 rounded-lg"
              onClick={handleCancel}
            />
            <CustomButton
              buttonType="primary"
              variant="ok"
              buttonText="Save"
              className=" text-sm px-6 py-2 rounded-lg"
              onClick={handleSave}
            />
          </div>
        </div>
        {showPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <PopupCard
              type={popupData.type}
              title={popupData.title}
              message={popupData.message}
            />
          </div>
        )}
      </DialogBox>
    </div>
  );
};

export default AddQuestion;
